import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import bandPhotos from './bandPhotos';

function PhotoGallery() {
  return (
    <Box component="section" id="gallery" sx={{ py: { xs: 8, md: 12 }, bgcolor: '#0b0909' }}>
      <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3, md: 5 } }}>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: 'minmax(0, 1.15fr) minmax(280px, 0.55fr)' },
            gap: { xs: 2, md: 8 },
            alignItems: 'end',
            mb: { xs: 4, md: 6 },
          }}
        >
          <Box>
            <Typography sx={{ color: 'primary.main', fontWeight: 700, mb: 1 }}>
              On stage
            </Typography>
            <Typography
              variant="h2"
              sx={{ fontSize: { xs: '3.25rem', sm: '4.5rem', md: '5.75rem' }, lineHeight: 0.95 }}
            >
              A night with Malpractice
            </Typography>
          </Box>
          <Typography sx={{ color: 'text.secondary', fontSize: '1rem', lineHeight: 1.7, maxWidth: 440 }}>
            Big vocals, sharp players, costume changes, and a dance floor that stays busy.
          </Typography>
        </Box>

        <Box
          className="contact-sheet-reveal"
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: 'repeat(2, minmax(0, 1fr))', sm: 'repeat(3, minmax(0, 1fr))', md: 'repeat(5, minmax(0, 1fr))' },
            gap: { xs: 1, sm: 1.5 },
          }}
        >
          {bandPhotos.map((photo, index) => (
            <Box
              component="figure"
              key={photo.src}
              sx={{
                m: 0,
                aspectRatio: '4 / 3',
                overflow: 'hidden',
                borderRadius: '2px',
                bgcolor: '#1f1714',
                position: 'relative',
                '&::after': {
                  content: '""',
                  position: 'absolute',
                  inset: 0,
                  border: '1px solid rgba(248, 241, 231, 0.12)',
                  pointerEvents: 'none',
                },
                '&:hover img': {
                  transform: 'scale(1.045)',
                  filter: 'saturate(1.08) brightness(1.05)',
                },
              }}
            >
              <Box
                component="img"
                src={photo.src}
                alt={photo.alt}
                loading={index < 4 ? 'eager' : 'lazy'}
                width="160"
                height="120"
                sx={{
                  display: 'block',
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  transition: 'transform 350ms ease, filter 350ms ease',
                }}
              />
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
}

export default PhotoGallery;
